import Logo from 'assets/images/wholesaler/logo/wholesalerLogo.svg';
import {useNavigate} from 'react-router-dom';
const Header = () => {
  const navigate = useNavigate();
  return (
    <>
      <div className=" bg-white w-full px-4 py-3 flex justify-between sticky top-0 z-10">
        <div className="flex">
          <img
            src={Logo}
            alt="logo"
            onClick={() => navigate('/wholesaler/home')}
          />
        </div>
        <span className="icon-notification text-2xl text-gray-6"></span>
      </div>
    </>
  );
};

export default Header;
